/* Action Types */
export const LOAD_ITEM_BIDDING_FAIL = 'la/domain/itemBidding/LOAD_FAIL';
export const LOAD_ITEM_BIDDING_REQUEST = 'la/domain/itemBidding/LOAD_REQUEST';
export const LOAD_ITEM_BIDDING_SUCCESS = 'la/domain/itemBidding/LOAD_SUCCESS';
